<template>

    <FloatingPanel title="Button">

        <div class="common-canvas-blocks-utils-button-BlockPanel">

            <div class="tw-pt-3 tw-px-4">

                <div class="tw-mb-1 tw-text-gray-600 label">Button tekst</div>

                <input
                        ref="text"
                        type="text"
                        class="form-control"
                        placeholder="Lees verder"
                        @blur="setText"
                        :value="options.text" />

            </div>

            <div class="tw-pt-3 tw-px-4">

                <div class="tw-mb-1 tw-text-gray-600 label">Openen op</div>

                <select
                        ref="target"
                        class="form-control"
                        placeholder="Openen op pagina"
                        v-model="options.target"
                        @blur="setTarget">
                    <option v-for="(label, target) in targets"
                            :key="target"
                            :value="target">{{ label }}</option>
                </select>

            </div>

            <div class="tw-pt-3 tw-px-4">

                <div class="tw-mb-1 tw-text-gray-600 label">Wat is het adres?</div>

                <input
                        ref="url"
                        type="text"
                        class="form-control"
                        placeholder="http://www."
                        @blur="setUrl"
                        :value="options.url" />

                <small class="tw-text-muted tw-block tw-mt-2">Gebruik voor externe websites de volledige url, dus ook met http(s)://.</small>

            </div>

        </div>

    </FloatingPanel>

</template>

<script>

    import AbstractPanel from "../../../../../../../js/common/canvas/editor/canvas/document/editors/AbstractPanel";
    import FloatingPanel
        from "../../../../../../../js/common/canvas/editor/canvas/document/editors/panels/FloatingPanel";

    export default {

        extends: AbstractPanel,

        components: {
            FloatingPanel,
        },

        data() {
            return {
                targets: {
                    '_self': 'Huidige pagina',
                    '_blank': 'Nieuwe pagina',
                },
            };
        },

        methods: {

            setText()
            {
                // Set
                this.$set(this.options, 'text', $(this.$refs['text']).val());
            },

            setUrl()
            {
                // TODO Validate
                // Set
                this.$set(this.options, 'url', $(this.$refs['url']).val());
            },

            setTarget()
            {
                // Set
                this.$set(this.options, 'target', $(this.$refs['target']).val());
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-blocks-utils-button-BlockPanel {

    }

</style>